import * as React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="footer">
      <p
        align="center"
        title="Bitcoin is a decentralized digital currency that enables Peer-to-Peer transactions without the need for intermediaries like banks. It operates on a public ledger blockchain that records all transactions in a secure and transparent manner. Bitcoin was created in 2009 by pseudonym Satoshi Nakamoto."
      >
        <a
          href="https://bitcoin.org/bitcoin.pdf"
          target="_blank"
          className="text-decoration-none text-secondary"
          onClick={scrollToTop}
        >
          Bitcoin: A Peer-to-Peer Electronic Cash System
        </a>
      </p>
      <div>
        <div>&copy; 2023-{currentYear}, bitcoin.bio</div>
        <div>
          <Link
            to="/"
            className="text-decoration-none text-secondary"
            onClick={scrollToTop}
            style={{ marginRight: "10px" }}
          >
            Home
          </Link>
          <Link
            to="/tools"
            className="text-decoration-none text-secondary"
            onClick={scrollToTop}
            style={{ marginRight: "10px" }}
          >
            Tools
          </Link>
          <Link
            to="/privacy"
            className="text-decoration-none text-secondary"
            onClick={scrollToTop}
          >
            Privacy
          </Link>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
}

export default Footer;
